import { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { DatasetProvider } from "../../contexts/DatasetContext";
import { Panel } from "../../components/panels/Panel";
import { AnnotationPageDatasets } from "./components/AnnotationPageDatasets";
import { AnnotationPageContent } from "./components/AnnotationPageContent";
import { AnnotationDiscardChangesModal } from "./components/AnnotationDiscardChangesModal";

export const AnnotationPage = () => {
  return (
    <DatasetProvider>
      <AnnotationDiscardChangesModal />
      <AnnotationPageView />
    </DatasetProvider>
  );
};

const AnnotationPageView = () => {
  const [isDatasetsOpen, setIsDatasetsOpen] = useState(true);

  return (
    <div className="h-full flex">
      {isDatasetsOpen ? (
        <div className="h-full w-1/5 shrink-0 p-3 pr-0">
          <Panel noHeader rounded category="secondary">
            <div className="h-full min-h-0 flex flex-col">
              <div className="shrink-0 flex justify-end pb-3">
                <button type="button"
                        className="flex items-center justify-center size-7 rounded-md bg-perception-black-600 text-perception-gray-300 hover:bg-perception-black-500 hover:text-white transition-colors"
                        onClick={() => setIsDatasetsOpen(false)}>
                  <ChevronLeftIcon className="size-5" />
                </button>
              </div>

              <div className="flex-1 min-h-0">
                <AnnotationPageDatasets />
              </div>
            </div>
          </Panel>
        </div>
      ) : (
        <div className="h-full w-9 shrink-0 flex items-start justify-center pt-3">
          <button type="button"
                  className="flex items-center justify-center size-7 rounded-md bg-perception-black-600 text-perception-gray-300 hover:bg-perception-black-500 hover:text-white transition-colors"
                  onClick={() => setIsDatasetsOpen(true)}>
            <ChevronRightIcon className="size-5" />
          </button>
        </div>
      )}

      <div className="h-full flex-1 min-w-0">
        <AnnotationPageContent compactLeftSpacing={!isDatasetsOpen} />
      </div>
    </div>
  );
};